var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.917 18.783L19.5 18.783M11.917 25.043L19.5 25.043M7.583 18.26c.3 0 .542.243.542.54 0 .3-.243.54-.542.54-.299 0-.541-.24-.541-.54 0-.297.242-.54.541-.54M11.917 12.522L19.5 12.522M7.583 12c.3 0 .542.242.542.54 0 .298-.243.54-.542.54-.299 0-.541-.242-.541-.54 0-.298.242-.54.541-.54M7.583 24.522c.3 0 .542.242.542.54 0 .298-.243.54-.542.54-.299 0-.541-.242-.541-.54 0-.298.242-.54.541-.54",
    transform: "translate(11 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.417 5.217h5.416c1.197 0 2.167.935 2.167 2.087v21.913c0 1.153-.97 2.087-2.167 2.087H2.167C.97 31.304 0 30.37 0 29.217V7.304c0-1.152.97-2.087 2.167-2.087h5.416C7.583 2.336 10.008 0 13 0s5.417 2.336 5.417 5.217z",
    transform: "translate(11 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4.174c.3 0 .542.242.542.54 0 .298-.243.54-.542.54-.3 0-.542-.242-.542-.54 0-.298.243-.54.542-.54",
    transform: "translate(11 8)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.eedc2cd3f0482eeb123ca9db3bf295cd.svg";
export { ForwardRef as ReactComponent };